import React from 'react';
import experts from '../assets/images/banner3.jpeg';

const Experts = () => {
  return (
    <div id="Experts">
      <section className="feature-service sec-padd2">
        <div className="container">
        <div className="section-title">
            <h2>What We Do?</h2>
          </div>
          <div className="row">
            {/* About Experts */}
            <div className="col-md-6 col-sm-12 col-lg-6 col-xl-6 col-xs-12 column style-2">
            
             
              <figure className="img-box">
                <a href="#">
                  
                   <img src={experts}
                    alt="About Experts"
                    className='img-fluid' style={{width:'600px',height:'360px'}}
                  />
                </a>
              </figure>
              <div className="text">
                {/* <p>
                Similarly we help IT candidates with searching and providing suitable jobs and we offer training and marketing their profiles
                </p> */}
              </div>
            </div>

            {/* What We Do */}
            <div className="col-md-6 col-sm-12 col-lg-6 col-xl-6 col-xs-12 column style-2">
              {/* <div className="section-title">
                <h2>What We Do</h2>
              </div> */}
              <div className="content">
                <div className="text">
                  <p>
                  At Saha Infotechs, we go beyond traditional job placement. We assist IT candidates by helping them find the best-suited job opportunities and enhancing their skills to succeed in the ever-evolving tech industry. Our comprehensive services include personalized job search assistance, training programs to upskill, and profile marketing to increase visibility among top employers.
                  </p>
                </div>
                <ul className="list">
                  <li><i className="fa fa-check"></i> Job Search Assistance</li>
                  <li><i className="fa fa-check"></i> Tailored Training Programs</li>
                  <li><i className="fa fa-check"></i> Interview Preparation</li>
                  <li><i className="fa fa-check"></i> Career Guidance</li>
                  <li><i className="fa fa-check"></i> Personalized Job Matching</li>
                  <li><i className="fa fa-check"></i> Skills Development & Training</li>
                </ul>
              </div>
            </div>

            {/* Business Growth */}
            {/* <div className="col-md-4 col-sm-6 col-xs-12 column style-3">
              <div className="section-title">
                <h2>Business Growth</h2>
              </div>
              <div className="graph">
                <figure className="graph-img">
                  <img src={experts} alt="Business Growth" />
                </figure>
                <form action="#" className="default-form">
                  <div className="select-box">
                    <select className="text-capitalize selectpicker form-control required" name="form_subject">
                      <option>Last 6 Months</option>
                      <option>Last 7 Months</option>
                      <option>Last 8 Months</option>
                      <option>Last 9 Months</option>
                    </select>
                  </div>
                </form>
              </div>
            </div> */}

          </div>
        </div>
      </section>
    </div>
  );
};

export default Experts;
